import {
  Component,
  effect,
  inject,
  Injector,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { MenuModule } from 'primeng/menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { Subscription } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterLinkFactory } from '../../../../core/router/router-link-factory';
import { IconsService } from '@rieaya-core';
import { BaseResponse } from '../../../../core/interfaces/base-response';
import { NotificationService as NotificationSignalRService } from '@rieaya-core';
import { environment } from '../../../../../environments/environment';
import { NotificationService } from '../../../../core/services/notification.service';
import { GetNotification } from '../../../../core/interfaces/notification';
import { TOKEN, USER_DATA } from '../../../../core/utils/constant';

@Component({
  selector: 'app-notifications',
  imports: [
    ButtonModule,
    BadgeModule,
    OverlayBadgeModule,
    MenuModule,
    CommonModule,
    RouterModule,
    TranslocoModule,
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
})
export class NotificationsComponent implements OnInit, OnDestroy {
  routerLinks = inject(RouterLinkFactory);
  icons = inject(IconsService);
  private notificationService = inject(NotificationService);
  private notificationSignalRService = inject(NotificationSignalRService);
  private injector = inject(Injector);

  notifications = this.notificationService.notifications;

  readonly unReadCount = this.notificationService.unReadCount;

  private _subs: Subscription[] = [];

  constructor() {
    effect(
      () => {
        const notification =
          this.notificationSignalRService.notificationSignal();

        if (notification) {
          const notificationObject: GetNotification = {
            id: `${notification.length}`,
            createdAt: new Date().toISOString(),
            isRead: false,
            message: notification,
          };
          this.notificationService.notifications.update((prevNotifications) => [
            notificationObject,
            ...prevNotifications,
          ]);
          this.notificationService.unReadCount.update(
            (prevCount) => prevCount + 1
          );
        }
      },
      { injector: this.injector }
    );
  }

  ngOnInit(): void {
    this.getUnreadNotifications();

    const token = localStorage.getItem(TOKEN) ?? '';
    const userId = JSON.parse(localStorage.getItem(USER_DATA) ?? '')?.id;

    this.notificationSignalRService.connect(environment.apiUrl, token, userId);
  }

  getUnreadNotifications() {
    this._subs.push(
      this.notificationService
        .getAll({ pageNumber: 1, pageSize: 10 })
        .subscribe({
          next: (response: BaseResponse<GetNotification[]>) => {
            this.notificationService.notifications.set(response.data);
          },
        })
    );
  }
  markAllAsRead() {
    this.notificationService.markAllAsRead().subscribe({
      next: () => {
        this.getUnreadNotifications();
      },
    });
  }

  ngOnDestroy(): void {
    this._subs.forEach((sub) => sub.unsubscribe());
    this.notificationSignalRService.stop();
  }
}
